import { render, staticRenderFns } from "./DataSetMetadataSchemaManage.vue?vue&type=template&id=790f03da&scoped=true"
import script from "./DataSetMetadataSchemaManage.vue?vue&type=script&lang=js"
export * from "./DataSetMetadataSchemaManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f03da",
  null
  
)

export default component.exports